import React, { useState, useEffect } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { getFormattedDate, convertToTimeString, getVimeoVideoJson } from '../../../../model/post';
import { AuthorLink, VimeoPlayer } from '../../index';
import { Episodes } from './index';
import DurationTimeIcon from '../../../../assets/svgs/duration-time.svg';
import VideoPlay from '../../../../assets/svgs/video-play.svg';
import VideoPlayMobile from '../../../../assets/svgs/video-play-mobile.svg';
import SocialLinks from '../social-icons';

const Header = ({
  subtitle,
  issueName,
  postImage,
  categories,
  postAuthors,
  documentaryEpisodes,
  documentarySponsors,
  location,
  socialUrls,
  handleCopyClick,
  isCopied,
}) => {
  const [currentEpisode, setCurrentEpisode] = useState(0);
  const [episodeTitle, setEpisodeTitle] = useState(
    documentaryEpisodes[0]?.documentaryEpisodesTitle,
  );
  const [episodeVideoCode, setEpisodeVideoCode] = useState(
    documentaryEpisodes[0]?.documentaryEpisodesVideo,
  );
  const [episodeAuthor, setEpisodeAuthor] = useState('');
  const [episodePublishDate, setEpisodePublishDate] = useState('');
  const [episodeDuration, setEpisodeDuration] = useState('');

  const onChangeEpisode = (episodeNum, videoCode) => {
    setCurrentEpisode(episodeNum);
    setEpisodeVideoCode(videoCode);
  };

  const [showVideo, setShowVideo] = useState(false);
  const [locationState, setLocationState] = useState(location.state);

  const onPlayVideo = () => setShowVideo(true);
  const onCloseVideo = () => setShowVideo(false);

  useEffect(() => {
    if (locationState?.videoCode) {
      setCurrentEpisode(locationState?.currentEpisode);
      setEpisodeVideoCode(locationState?.videoCode);
    }

    setEpisodeTitle(documentaryEpisodes[currentEpisode]?.documentaryEpisodesTitle);

    getVimeoVideoJson(episodeVideoCode)
      .then((response) => {
        setLocationState(null);
        setEpisodeAuthor(response?.author_name);
        setEpisodePublishDate(response?.upload_date);
        setEpisodeDuration(response?.duration);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [currentEpisode, documentaryEpisodes, episodeVideoCode, locationState]);

  const headElementListener = (e) => {
    const isEpisodeButton = !!e.target.closest('.documentary-episodes__button');

    if (!isEpisodeButton) {
      onPlayVideo();
    }
  };

  return (
    <>
      {showVideo && (
        <VimeoPlayer
          className="single-article__episode-video"
          onClose={onCloseVideo}
          videoCode={episodeVideoCode}
          videoTitle={episodeTitle}
          videoPostAuthors={postAuthors}
          videoAuthor={episodeAuthor}
          videoDuration={episodeDuration}
        />
      )}
      <header
        className={`single-article__header-wrapper documentary-header ${
          postImage && `documentary-header--featured-image`
        }`}
        onClick={headElementListener}
        role={'presentation'}
      >
        {(issueName || categories.length > 0) && (
          <div className="documentary-header__category">
            <div className="intro-titles">
              <div className="intro-titles__label">Film</div>
              {issueName && <div className="intro-titles__name">{issueName}</div>}
            </div>
          </div>
        )}
        <div className="documentary-header__head">
          <div className="documentary-header__head-inner">
            <div className="documentary-header__head-subtitle">{subtitle}</div>
            <div className="documentary-header__head-sponsors">
              {documentarySponsors &&
                documentarySponsors.nodes.map((node, idx) => (
                  <GatsbyImage alt="" image={node.gatsbyImage} key={idx} />
                ))}
            </div>
            <div className="documentary-header__head-episodes documentary-episodes">
              {documentaryEpisodes.length > 1 && (
                <Episodes
                  episodes={documentaryEpisodes}
                  onChangeEpisode={onChangeEpisode}
                  currentEpisode={currentEpisode}
                />
              )}
            </div>
            <h1 className="documentary-header__head-title">{episodeTitle}</h1>
            {documentaryEpisodes.length > 0 && (
              <div className="documentary-header__head-play">
                <VideoPlay className="documentary-header__head-play-desktop" />
                <VideoPlayMobile className="documentary-header__head-play-mobile" />
              </div>
            )}
            <div className="documentary-header__head-separator" />
            <div className="documentary-header__head-meta">
              {(postAuthors.length > 0 || episodeAuthor) && (
                <div className="documentary-header__head-author">
                  Directed by&nbsp;
                  {postAuthors.length > 0 ? (
                    postAuthors.map((author, idx) => (
                      <AuthorLink author={author} postAuthors={postAuthors} index={idx} key={idx} />
                    ))
                  ) : (
                    <div className="author-link">{episodeAuthor}</div>
                  )}
                </div>
              )}
              {episodePublishDate && (
                <div className="documentary-header__head-publish-date">
                  {getFormattedDate(episodePublishDate)}
                </div>
              )}
              {documentaryEpisodes.length > 0 && (
                <div className="documentary-header__head-duration-time">
                  {convertToTimeString(episodeDuration)} <DurationTimeIcon />
                </div>
              )}
            </div>
            <SocialLinks
              classname="documentary-header__head-social-media"
              simpleTwitterShareUrl={socialUrls.simpleTwitterShareUrl}
              simpleMatterShareUrl={socialUrls.simpleMatterShareUrl}
              simpleEmailShareUrl={socialUrls.simpleEmailShareUrl}
              handleCopyClick={handleCopyClick}
              isCopied={isCopied}
            />
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
